// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_datamessage.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_datamessage.proto.
 */
export const file_plugnmeet_datamessage: GenFile = /*@__PURE__*/
  fileDesc("ChtwbHVnbm1lZXRfZGF0YW1lc3NhZ2UucHJvdG8SCXBsdWdubWVldCKZAQoSRGF0YUNoYW5uZWxNZXNzYWdlEgoKAmlkGAEgASgJEigKBHR5cGUYAiABKA4yGi5wbHVnbm1lZXQuRGF0YU1zZ0JvZHlUeXBlEhQKDGZyb21fdXNlcl9pZBgDIAEoCRIXCgp0b191c2VyX2lkGAQgASgJSACIAQESDwoHbWVzc2FnZRgFIAEoCUINCgtfdG9fdXNlcl9pZCr9AwoPRGF0YU1zZ0JvZHlUeXBlEgsKB1VOS05PV04QABIPCgtGSUxFX1VQTE9BRBABEggKBElORk8QAhIJCgVBTEVSVBADEhoKFlVTRVJfVklTSUJJTElUWV9DSEFOR0UQBBIgChxFWFRFUk5BTF9NRURJQV9QTEFZRVJfRVZFTlRTEAUSFQoRTkVXX1BPTExfUkVTUE9OU0UQBhIbChdQVVNIX0pPSU5fQlJFQUtPVVRfUk9PTRAHEhwKGFJFUV9GVUxMX1dISVRFQk9BUkRfREFUQRAIEhwKGFJFU19GVUxMX1dISVRFQk9BUkRfREFUQRAJEhAKDFNDRU5FX1VQREFURRAKEhIKDlBPSU5URVJfVVBEQVRFEAsSHwobV0hJVEVCT0FSRF9BUFBfU1RBVEVfQ0hBTkdFEAwSDwoLUEFHRV9DSEFOR0UQDRIPCgtGSUxFX0NIQU5HRRAOEiQKIFVQREFURV9DVVJSRU5UX09GRklDRV9GSUxFX1BBR0VTEA8SFAoQV0hJVEVCT0FSRF9SRVNFVBAQEiIKHlVTRVJfQ09OTkVDVElPTl9RVUFMSVRZX0NIQU5HRRAREhgKFFJFUV9QVUJMSUNfQ0hBVF9EQVRBEBISGAoUUkVTX1BVQkxJQ19DSEFUX0RBVEEQExIMCghSRUFDVElPThAUQqIBCg1jb20ucGx1Z25tZWV0QhlQbHVnbm1lZXREYXRhbWVzc2FnZVByb3RvUAFaMmdpdGh1Yi5jb20vbXluYXBhcnJvdC9wbHVnbm1lZXQtcHJvdG9jb2wvcGx1Z25tZWV0ogIDUFhYqgIJUGx1Z25tZWV0ygIJUGx1Z25tZWV04gIVUGx1Z25tZWV0XEdQQk1ldGFkYXRh6gIJUGx1Z25tZWV0YgZwcm90bzM");

/**
 * @generated from message plugnmeet.DataChannelMessage
 */
export type DataChannelMessage = Message<"plugnmeet.DataChannelMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: plugnmeet.DataMsgBodyType type = 2;
   */
  type: DataMsgBodyType;

  /**
   * @generated from field: string from_user_id = 3;
   */
  fromUserId: string;

  /**
   * @generated from field: optional string to_user_id = 4;
   */
  toUserId?: string | undefined;

  /**
   * @generated from field: string message = 5;
   */
  message: string;
};

/**
 * Describes the message plugnmeet.DataChannelMessage.
 * Use `create(DataChannelMessageSchema)` to create a new message.
 */
export const DataChannelMessageSchema: GenMessage<DataChannelMessage> = /*@__PURE__*/
  messageDesc(file_plugnmeet_datamessage, 0);

/**
 * @generated from enum plugnmeet.DataMsgBodyType
 */
export enum DataMsgBodyType {
  /**
   * SYSTEM type
   *
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: FILE_UPLOAD = 1;
   */
  FILE_UPLOAD = 1,

  /**
   * @generated from enum value: INFO = 2;
   */
  INFO = 2,

  /**
   * @generated from enum value: ALERT = 3;
   */
  ALERT = 3,

  /**
   * @generated from enum value: USER_VISIBILITY_CHANGE = 4;
   */
  USER_VISIBILITY_CHANGE = 4,

  /**
   * @generated from enum value: EXTERNAL_MEDIA_PLAYER_EVENTS = 5;
   */
  EXTERNAL_MEDIA_PLAYER_EVENTS = 5,

  /**
   * @generated from enum value: NEW_POLL_RESPONSE = 6;
   */
  NEW_POLL_RESPONSE = 6,

  /**
   * @generated from enum value: PUSH_JOIN_BREAKOUT_ROOM = 7;
   */
  PUSH_JOIN_BREAKOUT_ROOM = 7,

  /**
   * WHITEBOARD type
   *
   * @generated from enum value: REQ_FULL_WHITEBOARD_DATA = 8;
   */
  REQ_FULL_WHITEBOARD_DATA = 8,

  /**
   * @generated from enum value: RES_FULL_WHITEBOARD_DATA = 9;
   */
  RES_FULL_WHITEBOARD_DATA = 9,

  /**
   * @generated from enum value: SCENE_UPDATE = 10;
   */
  SCENE_UPDATE = 10,

  /**
   * @generated from enum value: POINTER_UPDATE = 11;
   */
  POINTER_UPDATE = 11,

  /**
   * @generated from enum value: WHITEBOARD_APP_STATE_CHANGE = 12;
   */
  WHITEBOARD_APP_STATE_CHANGE = 12,

  /**
   * @generated from enum value: PAGE_CHANGE = 13;
   */
  PAGE_CHANGE = 13,

  /**
   * @generated from enum value: FILE_CHANGE = 14;
   */
  FILE_CHANGE = 14,

  /**
   * @generated from enum value: UPDATE_CURRENT_OFFICE_FILE_PAGES = 15;
   */
  UPDATE_CURRENT_OFFICE_FILE_PAGES = 15,

  /**
   * @generated from enum value: WHITEBOARD_RESET = 16;
   */
  WHITEBOARD_RESET = 16,

  /**
   * @generated from enum value: USER_CONNECTION_QUALITY_CHANGE = 17;
   */
  USER_CONNECTION_QUALITY_CHANGE = 17,

  /**
   * @generated from enum value: REQ_PUBLIC_CHAT_DATA = 18;
   */
  REQ_PUBLIC_CHAT_DATA = 18,

  /**
   * @generated from enum value: RES_PUBLIC_CHAT_DATA = 19;
   */
  RES_PUBLIC_CHAT_DATA = 19,

  /**
   * @generated from enum value: REACTION = 20;
   */
  REACTION = 20,
}

/**
 * Describes the enum plugnmeet.DataMsgBodyType.
 */
export const DataMsgBodyTypeSchema: GenEnum<DataMsgBodyType> = /*@__PURE__*/
  enumDesc(file_plugnmeet_datamessage, 0);

